
import React from "react";
import { Link } from "react-router-dom";

function Navbar3() {
  return (
    <nav className="navbar navbar-expand-xxl sticky-top">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img src="./s3/ads_navbar_brand.png"
            alt="ADS Sports Complex. Absolute Determination and Sacrifice"
            height="95"
          />
        </Link>
        <button className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <div className="btn btn-warning me-3 ms-3">
              <Link className="sports-program-button" to='/Volleyball'>
                VOLLEYBALL SIGNUP
              </Link>
              </div>
          
            <li className="nav-item">
              <Link className="nav-link futuraPTMedium" to="/Volleyball">Volleyball | </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link futuraPTMedium" to="/Basketball">Basketball | </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link futuraPTMedium" to="/FlagFootball">Flag Football | </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link futuraPTMedium" to="/#upcoming-events">Upcoming Events | </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link futuraPTMedium" to="/BookEvent">Book an Event | </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link futuraPTMedium" to="/TrainCarsRental">Event Rentals</Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link futuraPTMedium" to="/Contact">Contact Us</Link>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
    );
}

export default Navbar3;
